<template>
  <div class="package_list">
    <title-bar-back :title="'礼品卡使用记录'" @back="back">
      <div class="title_right"></div>
    </title-bar-back>
    <div class="switch_bar">
      <div v-for="(i, index) in barList" :key="index" class="switch_item">
        <span
          :class="{ bar_color: barIndex === index }"
          @click="clickBar(index)"
          >{{ i.title }}</span
        >
        <p v-if="barIndex === index" class="bar_line" />
      </div>
      <!-- <p class="switch_item">已兑换</p>
      <p class="switch_item">已被领取</p> -->
    </div>
    <van-pull-refresh v-model="loading" @refresh="onRefresh">
      <van-list
        v-model="loading"
        :finished="!queryCardVoucherUserRecordByPage.hasNextPage"
        finished-text="我已经到底啦～"
        @load="onLoad"
      >
        <div
          v-for="(i, index) in queryCardVoucherUserRecordByPage.rows"
          :key="index"
          class="list_item"
          @click="goCardDetail(i.id)"
        >
          <img src="@/assets/mine/bg_milk_used@2x.png" alt="" class="bg_img" />
          <div class="img_con">
            <!-- <img src="@/assets/mine/used_week@2x.png" alt="" class="com_img" /> -->
            <img :src="i.leftImg" alt="" class="com_img" />
            <div class="con_title">
              <div
                class="title_title font_weight500 font16 text_left line_height_22"
              >
                {{ i.voucherName }}
              </div>
              <div
                class="title_date font_weight400 font12 text_left line_height_16"
              >
                有效期：{{
                  i.effectType === 1
                    ? i.expireStartTime.substring(0, 10) +
                      "-" +
                      i.expireEndTime.substring(0, 10)
                    : "永久使用"
                }}
              </div>
              <div
                class="title_id font_weight400 font12 text_left line_height_16"
              >
                订单号：{{ i.buyOrderSn }}
              </div>
            </div>
            <img :src="barIndexImg(barIndex)" alt="" class="get_bg" />
            <!-- <img v-if="i === 2" src="/img/user/cardvoucher/used@2x.png" alt="" class="get_bg">
        <img v-if="i === 3" src="/img/user/cardvoucher/got@2x.png" alt="" class="get_bg"> -->
          </div>
        </div>
      </van-list>
    </van-pull-refresh>
  </div>
</template>

<script>
const TitleBarBack = () =>
  import("@/components/TitleBarBack").then(m => m.default || m);
export default {
  name: "UseList",
  components: {
    TitleBarBack
  },
  data() {
    return {
      barList: [
        {
          title: "已领取",
          index: 0
        },
        {
          title: "已被领取",
          index: 1
        },
        {
          title: "已兑换",
          index: 2
        },
        {
          title: "已失效",
          index: 3
        }
      ],
      barIndex: 0,
      loading: false,
      status: 3,
      clickBars: false
    };
  },
  computed: {
    queryCardVoucherUserRecordByPage() {
      return this.$store.getters.queryCardVoucherUserRecordByPage;
    }
  },
  created() {
    this.getData();
  },
  methods: {
    // queryCardVoucherUserRecordByPage
    getData(status = 0, pageNo = 1) {
      const params = {
        pageNo: pageNo,
        pageSize: 20,
        status
      };
      this.$store
        .dispatch("mine/queryCardVoucherUserRecordByPage", { params })
        .then(() => {
          this.loading = false;
          this.clickBars = false;
        })
        .catch(() => {});
    },
    onRefresh() {
      this.getData();
    },
    onLoad() {
      this.loading = false;
      if (
        this.queryCardVoucherUserRecordByPage.hasNextPage &&
        this.queryCardVoucherUserRecordByPage.pageNo <=
          this.queryCardVoucherUserRecordByPage.pageCount &&
        !this.clickBars
      ) {
        this.loading = true;
        const pageIndex = this.queryCardVoucherUserRecordByPage.pageNo + 1;
        console.log("onLoad");
        this.getData(this.status, pageIndex);
        // console.log("上拉完毕");
      }
    },
    back() {
      this.$router.back();
    },
    clickBar(index) {
      this.clickBars = true;
      this.barIndex = index;
      this.status = index;
      this.getData(index);
    },
    barIndexImg(barIndex) {
      switch (barIndex) {
        case 0:
          return require("@/assets/mine/geted@2x.png");
        case 1:
          return require("@/assets/mine/other_geted@2x.png");
        case 2:
          return require("@/assets/mine/used@2x.png");
        case 3:
          return require("@/assets/mine/un_used@2x.png");
      }
    },
    goCardDetail(id) {
      this.$router.push({
        path: "/mine/carddetail",
        query: {
          id
        }
      });
    }
  }
};
</script>

<style scoped>
.title_right {
  width: 36px;
}
.switch_bar {
  padding: 15px 0 0;
  font-size: 14px;
  font-weight: 400;
  color: rgba(34, 34, 34, 1);
  text-align: center;
  display: flex;
  background: #fff;
  margin-bottom: 12px;
}
.bar_color {
  color: #bf9264;
}
.switch_item {
  flex: 1;
}
.bar_line {
  margin: 6px auto 0;
  width: 24px;
  height: 3px;
  background: #bf9264;
  border-radius: 2px;
}

.list_item {
  font-size: 0;
  position: relative;
}
.bg_img {
  width: 100%;
}
.img_con {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  display: flex;
}
.com_img {
  width: 40px;
  height: 25px;
  margin: 23px 10px 0 30px;
}
.con_title {
  margin-top: 15px;
}
.title_title {
  color: #999;
}
.title_date {
  margin-top: 5px;
  color: rgba(153, 153, 153, 0.8);
}
.title_id {
  margin-top: 2px;
  color: rgba(153, 153, 153, 0.8);
}
.get_bg {
  width: 58px;
  height: 53px;
  margin: 65px 0 0 42px;
}
</style>
